import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ParentContentCard from '../common/ParentContentCard';
const moment = require('moment');
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import voca from 'voca';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';

export class PublishTracklogs extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    currentPage: 1,
    perPage: 25,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPublishtrack({ projectId });
  }

  handlePageChange = ({ selected }) => {
    console.log('selected', selected);
    this.setState({ currentPage: selected + 1 });
  };

  render() {
    const { currentPage, perPage } = this.state;
    const { publishTrack, projectDetail } = this.props.appSetting;
    const offset = (currentPage - 1) * perPage;
    const paginatedPublishTrack = publishTrack.slice(offset, offset + perPage);
    const totalPages = Math.ceil(publishTrack.length / perPage);
    if (!projectDetail) return '';
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'publish-activity'} projectDetail={projectDetail} />
        <ParentContentCard title="Publish Activity" icon="publish-activity">
          <table className="table table-bordered table-striped table-responsive-sm text-left p-3 m-2">
            <tbody>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>IP Address</th>
                <th>Environment</th>
                <th>Version</th>
                <th>Time</th>
              </tr>
              {paginatedPublishTrack.map((activity) => {
                const createdAt = new Date(activity.createdAt);
                const formattedTime = moment(createdAt).format('Do MMMM YYYY, h:mm a');
                const { _id, user, ip, projectVersion, environment = '' } = activity;
                return (
                  <tr key={_id}>
                    <td>{user.username}</td>
                    <td>{user.name}</td>
                    <td>{ip}</td>
                    <td>{voca.titleCase(environment)}</td>
                    <td>{projectVersion}</td>
                    <td>{formattedTime}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <CustomReactPaginate
            totalPages={totalPages}
            page={currentPage - 1}
            onPageChange={this.handlePageChange}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
          />
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PublishTracklogs);
